import { CardSvg } from '@/play/cardSvg'

/** Home card art: lumpy blobs covered in googly eyes of every size. */
export function EyeBrushCardArt() {
  const eyes: Array<[number, number, number, number, number]> = [
    // cx, cy, r, pupil dx, pupil dy
    [138, 92, 17, 5, 6], [176, 84, 13, -4, 6], [208, 100, 10, 3, 5], [160, 122, 8, 3, -3],
    [118, 128, 7, -2, 3], [196, 130, 9, 2, 4], [60, 120, 9, 3, 3], [82, 104, 6, -2, 2],
    [262, 128, 8, -3, 3], [248, 108, 5, 1, 2],
  ]
  return (
    <CardSvg bg="#fbe6b8">
      <rect y="156" width="320" height="44" fill="#e8f0d2" />
      {/* the creature mound with ears */}
      <circle cx="132" cy="54" r="16" fill="#ffb36b" />
      <circle cx="214" cy="54" r="16" fill="#ffb36b" />
      <path d="M86 160 C 86 70, 120 52, 172 52 S 258 70, 258 160 Z" fill="#ffb36b" />
      <ellipse cx="172" cy="148" rx="48" ry="16" fill="#ffd3a1" />
      {/* blobs and a rock */}
      <path d="M34 160 C 34 116, 50 100, 66 100 S 98 116, 98 160 Z" fill="#ff8fb8" />
      <path d="M240 160 C 240 120, 252 104, 266 104 S 292 120, 292 160 Z" fill="#7cc6ff" />
      <path d="M100 168 l 10 -14 l 16 -2 l 10 12 l -4 8 z" fill="#a2a9b0" />
      {eyes.map(([cx, cy, r, dx, dy], i) => (
        <g key={i}>
          <circle cx={cx} cy={cy} r={r} fill="#ffffff" stroke="#1d2b36" strokeWidth={Math.max(1.5, r / 7)} />
          <circle cx={cx + (dx * r) / 17} cy={cy + (dy * r) / 17} r={r * 0.5} fill="#1d2b36" />
        </g>
      ))}
      {/* the brush stroke the eyes came from */}
      <path d="M40 186 C 100 172, 180 192, 290 176" stroke="#ffffff" strokeWidth="6" strokeLinecap="round" fill="none" opacity="0.7" strokeDasharray="2 14" />
    </CardSvg>
  )
}
